













































































































































































	import { Component, Vue } from "vue-property-decorator";
	import { mapState } from "vuex";
	import {
		RedCapital,
		SelectedCountry,
		Configuration,
		TitleTemplateDashboard,
	} from "@/configuration";
	import Currency from "@/components/Currency.vue";
	import ReusableButton from "@/components/ReusableButton.vue";
	import API from "@/api";
	import DniField from "@/components/DniFieldBusiness.vue";
	import Modals from "@/components/modals/Modals.vue";
	import { EventBus } from "@/main";
	import AlertaAccion from "@/components/alertas/AlertaAccion.vue"
	import ShowLoading from "@/components/panel/ShowLoading.vue";

	@Component({
		computed: {
			...mapState(["user", "business", "setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			}
		},
		metaInfo: {
			title: "Solicitar credito",
			titleTemplate: TitleTemplateDashboard,
			htmlAttrs: {
				// @ts-ignore
				lang: RedCapital[SelectedCountry].Lang,
			},
		},
		data() {
			return {
				RedCapital,
				SelectedCountry,
				canShow: false,
				canShow2:false,
				hasBusiness: false,
				btn: {
					uploadCredit: {
						clickable: false,
						loading: false,
						isOk: null,
						successText: "Petición enviada",
						errorText: "Error al hacer la petición",
					},
				},
				statics: {
					business: null,
					businessName: null,
					businessSelected: 0,
					loading: false
				},
				valid: true,
				dialog: false,
				errorMessage: null,
				typeSelected: null,
				disableWarrantyInputs: true,
				credit: {
					amount: 0,
					reason: null,
					term: null,
					warranty: {
						selected: 0,
						cost: 0,
						debt: 0,
					},
				},
				warrantyTypes: [{
						id: 1,
						text: "Otra",
					},{
						id: 2,
						text: "Casa",
					},{
						id: 3,
						text: "Oficina",
					},{
						id: 4,
						text: "Terreno",
					},{
						id: 5,
						text: "Industrial",
					},{
						id: 6,
						text: "Local comercial",
					},{
						id: 7,
						text: "Agrícola",
					},
				],
				idEstadosSolicitud:[1,3,4,5,7,8,9,10,11,12,13,14,15],
				modalTipo: 0,
				rules: {
					notEmpty: [(v: any) => !!v || "Este campo es requerido"],
					amount: [
						(v: any) => !!v || "Monto a solicitar es requerido",
						(v: any) => /^\d+$/g.test(v) || "Tiene que ser solo numeros",
					],
					warranty: {
						cost: [(v: any) => !!v || "Valor de la garantía es requerido"],
						debt: [(v: any) => !!v || "Deuda de la garantía es requerido"],
					},
					reason: [(v: any) => !!v || "Motivo de la solicitud es requerido"],
					terms: [
						(v: any) => !!v || "Plazo de la garantía es requerido",
						(v: any) => /^\d+$/g.test(v) || "Tiene que ser solo numeros",
					],
					noVacioTextArea: [
						// @ts-ignore
						v => {
							if(!v || v.trim() === ''){
								return 'Campo requerido'
							}else if(v.trim().length < 10){
								return 'Ingrese al menos 10 caracteres'
							}else if(v.trim().length >= 150){
								this.$data.credit.reason = this.$data.credit.reason.trim();
								return true
							}else{
								return true
							}
						}
					],
				},
				showCheckDesc: false,
				textAreaMax150: '',
			};
		},
  	async beforeMount() {
			if(this.$store.state.user.empresas_count == 0 ){
				API.getBusiness()
					.then((res: any) => {
						this.$data.staticBusiness = res;
						if (res.length == 0) {
							this.$data.canShow2 = true;
							this.$data.hasBusiness = false;
						}else {
							this.$data.canShow2 = true;
							this.$data.hasBusiness = true;
						}
					})
					.catch((err: any) => {});
			}else{
				this.$data.statics.business = await API.getBusiness();
				if (this.$store.state.businesSelected != null) {
					this.$data.statics.businessSelected = this.$store.state.businesSelected.id;
					this.$data.canShow = true;
				} else {
					this.$data.statics.businessSelected = 0;
					this.$data.canShow = true;
				}
				this.$data.canShow2 = true;
				this.$data.hasBusiness = true;
			}
  	},
		watch: {
			credit: {
				handler() {
					// @ts-ignore
					if (this.$refs.credit.validate()) {
						if (this.$data.credit.warranty.selected > 0) {
							this.$data.btn.uploadCredit.clickable = true;
						} else {
							this.$data.btn.uploadCredit.clickable = false;
						}
					} else {
						this.$data.btn.uploadCredit.clickable = false;
					}
				},
				deep: true,
			},
			"credit.warranty.selected"(val) {
				if (val == 0 || val == 1) {
					this.$data.disableWarrantyInputs = true;
				} else {
					this.$data.disableWarrantyInputs = false;
				}
			},
			"statics.businessSelected"(newVal){ // TODO: desbloquear
				if(newVal != 0){
					this.$data.statics.loading = true;
					API.requestsByCompanyId(newVal)
						.then((res:any)=>{
							if(res.creditos.length > 0){
								let creditoConGarantia = res.creditos.find((element : any) => element.garantia != null);
								if(creditoConGarantia != undefined && this.$data.idEstadosSolicitud.includes(creditoConGarantia.estado_solicitud_id)){
									this.$data.statics.businessSelected = 0;
									setTimeout(()=>{
										// @ts-ignore
										this.$refs.credit.resetValidation();
									})
									// @ts-ignore
									this.modal(4);
								}
							}
							this.$data.statics.loading = false;
						})
				}
			},
			'credit.reason' (val: any){
				if(val != null && val.trim().length <= 150 && val.trim().length > 9){
					if(this.$data.textAreaMax150 != ''){
						this.$data.textAreaMax150 = '';
					}
					if(val.trim().length == 150){
						this.$data.textAreaMax150 = val 
					}
					this.$data.showCheckDesc = true;
				} else {
					this.$data.showCheckDesc = false;
				}
				if(val != null && val.trim().length > 150){
					this.$data.credit.reason = '';
					setTimeout(() => {
						this.$data.credit.reason = this.$data.textAreaMax150;	
					});
					this.$data.showCheckDesc = false;
				}
			},
		},
  	methods: { 
			createbussiness() {
				API.getBusiness2(this.$store.state.user.id).then((res: any) => {
					this.$data.businessData = res;
					//@ts-ignore
					let url= window.location.pathname;
					if (this.$data.businessData.length == 0) {
						this.$router.push({ name:"dashboard-factoring-create-bussiness", params: { origen: url}});
					}
					if (this.$data.businessData.length == 1) {
						this.$store.commit("setBusinessSelected", this.$data.businessData[0]);
					} else if (this.$data.businessData.length > 1) {
						if (this.$store.state.businesSelected == null) {
							setTimeout(() => {
								EventBus.$emit("multibusiness", true);
							}, 1000);
						}
					}
				});
			},
			modal(tipo){ // Funcion encargada de mostrar modales
				this.$data.modalTipo = 0;
				setTimeout(() => {
					this.$data.modalTipo = tipo;	
				});
			},
    	uploadCredit() {
      	// @ts-ignore
      	if (this.$refs.credit.validate()) {
					this.$data.valid = true;
					this.$data.errorMessage = null;
					API.request.credit(
            this.$data.statics.businessSelected,
            this.$data.credit.reason,
            this.$data.credit.amount,
            this.$data.credit.term,
            {
              garantia_id: this.$data.credit.warranty.selected,
              valor: this.$data.credit.warranty.cost,
              deuda: this.$data.credit.warranty.debt,
            }
          )
          .then((data) => {
            this.$data.dialog = true;
            setTimeout(() => {
              this.$router.push({
                path: "/panel-facto/mis-operaciones",
              });
            }, Configuration.Redirection.timeout);
          })
          .catch((error) => {
            this.$data.errorMessage = "Revise los campos e intente nuevamente";
          });
      	}
    	},
  	},
		components: {
			Currency,
			ReusableButton,
			DniField,
			AlertaAccion,
			Modals,
			ShowLoading
		},
	})
  export default class Credit extends Vue {}
